import queryString from 'query-string';
import {
  API_ENDPOINT,
  useClientApiV1ResumeHubSummaryQuery,
} from '../../resources/@types/rallitSchema';

function useClientResumeHubSummaryQuery(
  accountId: number,
  options?: Parameters<typeof useClientApiV1ResumeHubSummaryQuery>[0]['options'],
) {
  return useClientApiV1ResumeHubSummaryQuery({
    queryKey: [API_ENDPOINT.CLIENT_V1_RESUME_HUB_SUMMARY, accountId],
    url: queryString.stringifyUrl({
      url: API_ENDPOINT.CLIENT_V1_RESUME_HUB_SUMMARY,
      query: {
        accountId,
      },
    }),
    options,
  });
}

export const getResumeHubSummaryQueryKey = () => [API_ENDPOINT.CLIENT_V1_RESUME_HUB_SUMMARY];

export default useClientResumeHubSummaryQuery;
